(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('SummaryService', SummaryService);

    SummaryService.$inject = ['$http', 'API_URL'];

    function SummaryService ($http, API_URL) {

        var service = {
            loadSummaryLabels:loadSummaryLabels,
            loadSummaryDocuments:loadSummaryDocuments
        };

        function loadSummaryLabels() {
            return $http.get(API_URL + 'project/summary');
        }

        function loadSummaryDocuments() {
            return $http.get(API_URL + 'project/summarydocuments');
        }

        return service;
    }
})();
